/* -----------------------------------------------------------------
 * App.jsx — Root: parse URL params, pass Name + App → Layout, render Charts
 *         + Admin-only ForecastDashboard (auto for UserID=admin OR kristie)
 * ----------------------------------------------------------------- */
import React from "react";
import Layout from "./components/Layout";
import Charts from "./components/Charts";
import ForecastDashboard from "./components/ForecastDashboard";
import "./index.css";

/** Read a query param with case-insensitive alternatives */
function getParam(qs, ...keys) {
  for (const k of keys) {
    const v = qs.get(k);
    if (v !== null && v !== undefined && v !== "") return v;
  }
  return "";
}

/** Basic path sanitization for the App param */
function sanitizeAppPath(raw) {
  if (!raw) return "";
  let v = String(raw).trim();
  // Strip protocol and domain if someone pasted a full URL
  v = v.replace(/^[a-z]+:\/\/[^/]+/i, "");
  // Remove leading slashes; we’ll add exactly one later
  v = v.replace(/^\/+/, "");
  // Keep only safe characters for a path
  v = v.replace(/[^a-z0-9/_\-]/gi, "");
  return v;
}

function isAdminUser(userId) {
  const u = String(userId || "")
    .trim()
    .toLowerCase();
  return u === "admin" || u === "kristie";
}

export default function App() {
  const qs = new URLSearchParams(window.location.search);

  // Company display name: prefer ?Name=, fallback ?Company=, then default
  const rawName =
    getParam(qs, "Name", "name") ||
    getParam(qs, "Company", "company") ||
    "OGPumper";
  const companyName = decodeURIComponent(rawName);

  // Subdomain for back navigation
  const subdomain = getParam(qs, "Company", "company") || "testtwo";

  // App path (optional)
  const appPath = sanitizeAppPath(getParam(qs, "App", "app"));

  // Pass-through to Charts (unchanged behavior)
  const initialParams = {
    Rpt: getParam(qs, "Rpt", "rpt") || "CD",
    QD: getParam(qs, "QD", "qd"),
    LeaseID: getParam(qs, "LeaseID", "leaseid") || "~ALL~",
    FromDate: getParam(qs, "From", "FromDate", "from", "fromdate"),
    ThruDate: getParam(qs, "Thru", "ThruDate", "thru", "thrudate"),
    UserID: getParam(qs, "UserID", "user", "userID", "userid"),
    token: getParam(qs, "token"),
    grant: getParam(qs, "grant"),
    Company: getParam(qs, "Company", "company"),
    Name: getParam(qs, "Name", "name"),
  };

  // Admin-only Forecast view (no View param needed)
  const admin = isAdminUser(initialParams.UserID);
  const showForecast = admin;

  return (
    <Layout companyName={companyName} subdomain={subdomain} appPath={appPath}>
      {showForecast ? (
        <ForecastDashboard />
      ) : (
        <Charts initialParams={initialParams} />
      )}
    </Layout>
  );
}
